export const featuresItems = [
  {
    title: "Available Anywhere",
    description:
      "Use /soma in channels or right-click messages to ask questions with context. Works in servers, group chats, and DMs.",
  },
  {
    title: "Open Source & Self-Hostable",
    description:
      "Run your own Soma instance on Cloudflare Workers. Fully open to contribute features and easy to deploy",
  },
  {
    title: "Chat Memory",
    description:
      "Remembers the last 10 messages of chat per channel for 24 hours, so it understands follow-up questions and ongoing threads.",
  },
  {
    title: "Web Search",
    description:
      "Looks up real-time info and docs when needed — perfect for debugging, fact-checking, or research.",
  },
];
